(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const _domAbas = document.querySelector(".abas");

    if (!_domAbas) {
      return;
    }

    // Alterar aba ativa
    _domAbas.querySelectorAll(".abas_list_btn").forEach((__domBtn) =>
      __domBtn.addEventListener("click", () => {
        try {
          const ___domBtnAtivo = _domAbas.querySelector(
            '.abas_list_btn[aria-selected="true"]'
          );

          window.requestAnimationFrame(() => {
            try {
              ___domBtnAtivo.setAttribute("aria-selected", "false");
              document
                .getElementById(___domBtnAtivo.getAttribute("aria-controls"))
                .setAttribute("hidden", "hidden");

              __domBtn.setAttribute("aria-selected", "true");
              document
                .getElementById(__domBtn.getAttribute("aria-controls"))
                .removeAttribute("hidden");
            } catch (error) {}
          });
        } catch (error) {}
      })
    );
  });
})();
